@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../packing-recommend/packing-applied.module.less';

@text-and-icon-color: var(--primary-button--text-color);

.package-editor-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--grey-600);
  border-radius: 10px;
  height: 20px;
  color: @text-and-icon-color;
  width: 100%;

  .package-editor-button-icon {
    padding: @space-0;
    height: 12px;
    width: 8px;
    fill: @text-and-icon-color;
  }
}

.multi-package-button {
  padding: 2px @space-4;
  flex-shrink: 0;
}

.multi-package-button-icon {
  margin-right: @space-4;
}

.package-buttons-container {
  display: flex;
  align-items: center;
  gap: @space-4;
  flex-wrap: wrap;
  max-width: 100%;
  overflow: visible;
}

@import '../packing-recommend/packing-applied-classes.module.less';

.packing-applied-dropdown {
  position: relative;
  border: 1.5px solid @packing-highlight-border;
  border-radius: 4px;
  background-color: @packing-highlight-bg;

  // override default border/bg on inner combobox/dropdown elements
  button[role='combobox'],
  button[class*='dropdown-toggler'] {
    background-color: @packing-highlight-bg !important;
    color: @packing-highlight-text !important;
    border: none !important;
  }

  input {
    background-color: @packing-highlight-bg !important;
    color: @packing-highlight-text !important;
    border: none !important;
  }

  svg {
    fill: @packing-highlight-text;
  }
}
